import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Wrench, X, Check } from 'lucide-react';

const ToolsPermissionsEditor = ({
  userId,
  userName,
  availableApps,
  selectedPermissions,
  onToggle,
  onSave,
  onCancel,
  loading
}) => {
  return (
    <Card className="bg-amber-50/20 dark:bg-amber-900/10 border-2 border-amber-500 rounded-2xl p-6 mb-6 animate-scale-in">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
            <Wrench className="w-5 h-5 text-amber-600 dark:text-amber-400" />
          </div>
          <h4 className="text-lg font-semibold text-foreground">
            Gestionare Permisiuni Tools Area - {userName}
          </h4>
        </div>
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="ghost"
            onClick={onCancel}
            className="rounded-xl"
            data-testid="tools-permissions-cancel"
          >
            <X className="w-4 h-4 mr-1" />
            Anulează
          </Button>
          <Button
            size="sm"
            className="rounded-xl bg-amber-500 hover:bg-amber-600 text-white"
            onClick={() => onSave(userId)}
            disabled={loading}
            data-testid="tools-permissions-save"
          >
            <Check className="w-4 h-4 mr-1" />
            Salvează
          </Button>
        </div>
      </div>

      <div className="space-y-3">
        <p className="text-sm text-muted-foreground mb-4">
          Selectează aplicațiile din Tools Area la care utilizatorul va avea acces:
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {availableApps.map((app) => (
            <div
              key={app.id}
              onClick={() => onToggle(app.id)}
              className={`p-3 rounded-xl border-2 cursor-pointer transition-all duration-200 ${
                selectedPermissions.includes(app.id)
                  ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20'
                  : 'border-border hover:border-amber-300 dark:hover:border-amber-700'
              }`}
              data-testid={`tools-perm-${app.id}`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                  selectedPermissions.includes(app.id)
                    ? 'border-amber-500 bg-amber-500'
                    : 'border-muted-foreground'
                }`}>
                  {selectedPermissions.includes(app.id) && (
                    <Check className="w-3 h-3 text-white" />
                  )}
                </div>
                <span className="font-medium text-foreground">{app.name}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl">
          <p className="text-sm text-muted-foreground">
            <strong>Aplicații selectate:</strong> {selectedPermissions.length} din {availableApps.length}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default ToolsPermissionsEditor;
